import { render, staticRenderFns } from "./ProductBlockVideoElement.vue?vue&type=template&id=5a310f47&"
import script from "./ProductBlockVideoElement.vue?vue&type=script&lang=js&"
export * from "./ProductBlockVideoElement.vue?vue&type=script&lang=js&"
import style0 from "./ProductBlockVideoElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports